import { API_BASE_URL } from "@/api/config";
import { type MfaResponse, type MfaSendResponse, type LoginResponse, type TrialRegisterResponse } from "@/api/schemas/auth";
import { fetchOptions } from "./options";
import { apiResponseHandler } from "./handlers";

export async function login(username: string, password: string): Promise<LoginResponse> {
  const body = {
    username: username.toLowerCase(),
    password: password,
  }
  const data = await fetch(`${API_BASE_URL}/users/login`, fetchOptions("POST", body))
  return apiResponseHandler<LoginResponse>(data, "Erro ao fazer login")
}

export async function logout(){
  const response = await fetch(`${API_BASE_URL}/users/logout`, fetchOptions("GET"))
  return apiResponseHandler(response, "Erro ao fazer logout")
}

export async function fetchPasswordResetEmail(email: string) {
  const body = { email }
  const response = await fetch(`${API_BASE_URL}/users/password/reset`, fetchOptions("PUT", body))
  return apiResponseHandler(response, "Erro ao enviar email de redefinição de senha")
}

export async function changeUserPassword(email: string, code: string, password: string, confirm_password: string) {
  const body = { email, code, password, confirm_password }
  const response = await fetch(`${API_BASE_URL}/users/password/change`, fetchOptions("PUT", body))
  return apiResponseHandler(response, "Erro ao alterar senha")
}

export async function sendMfaCode(username: string): Promise<MfaSendResponse> {
  const body = { email: username }
  const response = await fetch(`${API_BASE_URL}/users/mfa/send-code`, fetchOptions("POST", body, "aplication/json"))
  return apiResponseHandler<MfaSendResponse>(response, "Erro ao enviar código MFA")
}

export async function validateMfaCode(username: string, code: string): Promise<MfaResponse> {
  const body = { email: username, code: code }
  const response = await fetch(`${API_BASE_URL}/users/mfa/verify`, fetchOptions("POST", body, "aplication/json"))
  return apiResponseHandler<MfaResponse>(response, "Erro ao validar código MFA")
}

export async function registerTrial(
  email: string,
  password: string,
  username: string,
  profile: string,
): Promise<TrialRegisterResponse> {
  const body = {
    email,
    password,
    username,
    profile
  }
  const response = await fetch(`${API_BASE_URL}/users/register/trial`, fetchOptions("POST", body));
  return apiResponseHandler<TrialRegisterResponse>(response, "Erro ao criar conta trial")
}


export async function generateSupportPassword() {
  const response = await fetch(`${API_BASE_URL}/users/generate-support-password`, fetchOptions("POST"));
  return apiResponseHandler(response, "Erro ao gerar código de suporte")
}

export async function validateSupportPassword(email: string, password: string) {
  const response = await fetch(`${API_BASE_URL}/users/validate-support-password`, {
    ...fetchOptions("POST", { email, password }),
  });
  return apiResponseHandler(response, "Erro ao validar código de suporte");
}




export async function validate():Promise<{message: string}>{
  const response = await fetch(`${API_BASE_URL}/users/validate`, fetchOptions("GET"))
  return apiResponseHandler(response, "Erro ao validar sessão")
}